module.exports = __webpack_public_path__ + "img/culture_4.823cd3a7.jpg";